<template>
  <b-container fluid id="app" style="background-color: transparent;">
    <BusTracker v-if="this.$route.fullPath.startsWith('/bus-tracker')"/>
    <ArrDepBoard v-else-if="this.$route.fullPath.startsWith('/arr-dep-board')"/>
    <ArrDepBoardLg v-else-if="this.$route.fullPath.startsWith('/arr-dep-lg-board')"/>
    <SOSDetail v-else-if="this.$route.fullPath.startsWith('/sos_map')"/>
    <VehicleMapDirect v-else-if="this.$route.fullPath.startsWith('/map')"/>
    <VehicleMapDriver v-else-if="this.$route.fullPath.startsWith('/drivermap')"/>
    <VehicleMapTrack v-else-if="this.$route.fullPath.startsWith('/vehicle-track')"/>
    <VehicleMapTrackFleetFabbus v-else-if="this.$route.fullPath.startsWith('/fleet-track-fabbus')"/>
    <VehicleMapTrackFleet v-else-if="this.$route.fullPath.startsWith('/fleet-track')"/>
    <VehicleMapTrackBooking v-else-if="this.$route.fullPath.startsWith('/booking-track')"/>
    <RegisterDirect v-else-if="this.$route.fullPath.startsWith('/register')"/>
    <VehStatusTBNDVIR v-else-if="this.$route.fullPath.startsWith('/status')"/>
    <VehStatusMaintTBN v-else-if="this.$route.fullPath.startsWith('/vsm-maint-tbn')"/>
    <VehStatusMaint v-else-if="this.$route.fullPath.startsWith('/vsm-maint')"/>
    <VehMaintSummary v-else-if="this.$route.fullPath.startsWith('/veh-maint-summary')"/>
    <VehStatusTBN v-else-if="this.$route.fullPath.startsWith('/vsm-tbn')"/>
    <VehStatusFasttrakDVIR v-else-if="this.$route.fullPath.startsWith('/vsm-fasttrak')"/>
    <PlannedVehicleTypesMonthlyTBN v-else-if="this.$route.fullPath.startsWith('/vehicle-util-monthly-tbn')"/>
    <PlannedDriverTypesMonthlyTBN v-else-if="this.$route.fullPath.startsWith('/driver-util-monthly-tbn')"/>
    <PlannedDriverTypesMonthlyCM v-else-if="this.$route.fullPath.startsWith('/driver-util-monthly-cm')"/>
    <VehStatus v-else-if="this.$route.fullPath.startsWith('/vsm-v1')"/>
    <VehStatusES v-else-if="this.$route.fullPath.startsWith('/vsm-es')"/>
    <VehStatusDVIR v-else-if="this.$route.fullPath.startsWith('/vsm')"/>
    <BookingCustomerFleetMap v-else-if="this.$route.fullPath.startsWith('/booking-customer-map')"/>
    <div v-else-if="authenticated">
      <navbar @authenticated="setAuthenticated" v-if="authenticated"/>
      <!-- FI-1432: site-wide banner for active service alerts. self-gates on
           the vuex notification list so no render cost when there's no alert. -->
      <ServiceAlertBanner />
      <b-alert v-model="alert.show" :variant="alert.variant" dismissible fade id="root-alert">
        {{alert.message}}
      </b-alert>
<!--      <div v-if="telematics_type==='SAMSARA'" style="background-color: darkgoldenrod; font-size: 20px; font-weight: bold; color: white">THERE WAS A SAMSARA OUTAGE ON 2/23 THAT MAY HAVE IMPACTED YOUR ACCOUNT - <a target="_blank" href="https://www.samsarastatus.com/#">DETAILS HERE</a></div>-->

      <router-view @authenticated="setAuthenticated" @showAlert="showAlert" />
      <FleetAssistantLauncher v-if="$route.name !== 'fleet_assistant' && user && user.features && user.features[user.tenant] && user.features[user.tenant].fleet_assistant_enabled !== false && (user.role === 'admin' || user.role === 'customer-admin' || user.role === 'tbn-admin' || user.role === 'manager' || user.role === 'dispatch') && !(user.preferences && user.preferences.hide_fleet_assistant_launcher)" @showAlert="showAlert" />
      <AiUsageRequestModal @showAlert="showAlert" />
      <div style="color: #007ac7; font-family: 'inherit' ;font-size: 24px; margin:100px 100px 50px 100px; padding:20px; border-top: 2px dotted #ccc;">
        powered by &#8594; <a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img height="40" src="/initek-logo.png"/></a>
        <span v-if="user.role == 'admin'" style="font-size: 18px"><br/>{{user.tenant}}</span>
      </div>
    </div>
    <div v-else id="login_top" style="min-height:100vh;background-size:contain;overflow:hidden">
      <Login @authenticated="setAuthenticated" @showAlert="showAlert"/>
    </div>
  </b-container>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import navbar from './components/navbar'
import Login from './components/login'
import SOSDetail from './components/sos_detail'
import VehicleMapDirect from './components/vehicle_map_direct'
import VehicleMapDriver from './components/vehicle_map_driver'
import PlannedVehicleTypesMonthlyTBN from './components/planned_vehicle_types_monthly_tbn.vue'
import PlannedDriverTypesMonthlyTBN from './components/planned_driver_types_monthly_tbn.vue'
import PlannedDriverTypesMonthlyCM from './components/planned_driver_types_monthly_cm.vue'
import VehicleMapTrack from './components/vehicle_map_track'
import VehicleMapTrackFleet from './components/vehicle_map_track_fleet'
import VehicleMapTrackFleetFabbus from './components/vehicle_map_track_fleet_fabbus'
import BookingCustomerFleetMap from './components/booking_customer_fleet_map'
import VehicleMapTrackBooking from './components/vehicle_map_by_booking'
import RegisterDirect from './components/direct_register'
import VehStatusTBNDVIR from './components/vehicle_status_dvir_tbn'
import VehStatusFasttrakDVIR from './components/vehicle_status_dvir_fasttrak'
import VehStatusMaintTBN from './components/vehicle_status_maint_tbn'
import VehStatusMaint from './components/vehicle_status_maint'
import VehMaintSummary from './components/vehicle_maint_summary'
import VehStatusTBN from './components/vehicle_status_tbn'
import VehStatus from './components/vehicle_status'
import VehStatusES from './components/vehicle_status_es'
import VehStatusDVIR from './components/vehicle_status_dvir'
import BusTracker from './components/bus_tracker'
import ArrDepBoard from './components/arrivals_departures_board'
import ArrDepBoardLg from './components/arrivals_departures_board_large'
import Planned_vehicle_types_monthly_tbn from "./components/planned_vehicle_types_monthly_tbn.vue";
import FleetAssistantLauncher from './components/fleet_assistant_launcher.vue'
import AiUsageRequestModal from './components/ai_usage_request_modal.vue'
import ServiceAlertBanner from './components/service_alert_banner.vue'
import { launchTutorial } from './utils/tutorials'
import {
  get_notifications_unread_count as cm_get_unread_count,
  get_user_notifications as cm_get_user_notifications,
} from './networking/apis'
import {
  tbn_get_notifications_unread_count,
  tbn_get_user_notifications,
} from './networking/tbn_apis'
// FI-1657: live-push WebSocket client. when VUE_APP_WS_URL is empty (DEV
// or stages where the WS API hasn't been provisioned) we skip WS entirely
// and fall back to the legacy 60s poll cadence, see startNotificationsPolling.
import NotificationsWs from './networking/notifications_ws'

// FI-1657 polling cadence. polling runs at 60s ONLY when the WS isn't
// open. while WS is connected we stop the timer entirely and rely on
// push signals + nc-refresh (dropdown open) + the post-(re)connect
// pollNotifications priming to keep state fresh. on any close we
// immediately restart the 60s timer so a dropped WS is invisible to
// the user.
const POLL_INTERVAL_FAST_MS = 60000

export default {
  name: 'App',
  metaInfo: {
          title: "Fleet Integrations",
          titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      authenticated: false,
      alert: {
        show: false,
        message: '',
        variant: ''
      },
    }
  },
  components: {
    Planned_vehicle_types_monthly_tbn,
    navbar, Login, SOSDetail, VehicleMapDirect, VehicleMapDriver, VehicleMapTrack, VehicleMapTrackFleet, VehicleMapTrackFleetFabbus, BookingCustomerFleetMap, VehicleMapTrackBooking, RegisterDirect, VehStatusTBNDVIR, VehStatusFasttrakDVIR, VehStatusTBN, VehStatusDVIR, VehStatusMaintTBN, VehStatusMaint, VehStatus, VehStatusES, VehMaintSummary, BusTracker, ArrDepBoard, ArrDepBoardLg, PlannedVehicleTypesMonthlyTBN, PlannedDriverTypesMonthlyTBN, PlannedDriverTypesMonthlyCM, FleetAssistantLauncher, AiUsageRequestModal, ServiceAlertBanner
  },
  created() {
    // iOS 17+ interactive-widget hint: tells Safari to resize the layout
    // viewport when the soft keyboard opens instead of shoving fixed content
    // off-screen to "reveal" a focused input. without this, the Fleet
    // Assistant mobile panel's header gets pushed past the top edge when the
    // user taps into the textarea. older browsers ignore unknown keys, so
    // this is a safe progressive enhancement. runtime injection because the
    // dev server may have an older HTML template cached — the static
    // public/index.html has the same hint baked in for prod builds.
    const vp = document.querySelector('meta[name="viewport"]')
    if (vp && !(vp.getAttribute('content') || '').includes('interactive-widget')) {
      const cur = (vp.getAttribute('content') || 'width=device-width, initial-scale=1').replace(/,\s*$/, '')
      vp.setAttribute('content', cur + ', interactive-widget=resizes-content')
    }

    const hashPath = (window.location.hash || '').replace(/^#/, '')
    const routePath = this.$route.fullPath || ''
    if (routePath.startsWith('/vehicle-util-monthly-tbn') || routePath.startsWith('/driver-util-monthly-tbn') || routePath.startsWith('/driver-util-monthly-cm') || routePath.startsWith('/bus-tracker') || routePath.startsWith('/arr-dep') || routePath.startsWith('/sos_map') || routePath.startsWith('/map') ||
        routePath.startsWith('/drivermap') || routePath.startsWith('/vehicle-track') || routePath.startsWith('/fleet-track') || routePath.startsWith('/booking-track') ||
        routePath.startsWith('/register') || routePath.startsWith('/status') || routePath.startsWith('/vsm') || routePath.startsWith('/veh-maint-summary') ||
        routePath.startsWith('/fleet-track-fabbus') || hashPath.startsWith('/fleet-track-fabbus') || routePath.startsWith('/booking-customer-map')) {
      return;
    }

    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

    if (user == null || this.$route.name == "login") {
      this.$router.replace({name: "login", params: {nextUrl: this.$route.fullPath}});
    } else {
      let selected_tenant = localStorage.getItem('selected_tenant')
      if (selected_tenant != null) {
        console.log("setting previously selected tenant: " + selected_tenant)
        user.tenant = selected_tenant
      }

      this.set_user_data(user)
      this.authenticated = true;
      // FI-1432: kick off the notification polling once we know the user
      // is authenticated on page load. new sessions that arrive via login
      // flip authenticated through setAuthenticated(true) which has its
      // own watcher below.
      this.startNotificationsPolling()
    }
  },
  mounted() {
    // FI-1432: navbar emits 'nc-refresh' through the root bus whenever the
    // profile dropdown opens. run an immediate poll so the badge + list
    // reflect current state instead of waiting up to 60s for the next tick.
    this._ncRefreshHandler = () => {
      if (this.authenticated) this.pollNotifications(true)
    }
    this.$root.$on('nc-refresh', this._ncRefreshHandler)

    // FI-1432: global click delegation for tutorial pills. markdown
    // authored with [Show me](tutorial:id) renders a pill anchor with
    // data-tutorial-id set. one document-level listener covers every
    // surface that renders markdown (announcements, help articles,
    // support tickets, fleet-assistant replies) without requiring each
    // component to wire its own handler.
    this._tutorialClickHandler = (event) => {
      const el = event.target && event.target.closest && event.target.closest('[data-tutorial-id]')
      if (!el) return
      event.preventDefault()
      const id = el.getAttribute('data-tutorial-id')
      if (!id) return
      launchTutorial(id, { router: this.$router, root: this.$root, isTbn: this.isTbnTenant() })
    }
    document.addEventListener('click', this._tutorialClickHandler)
    // FI-1432: NO visibilitychange handler. previously we paused the
    // 60s polling setInterval while the tab was hidden and primed an
    // immediate fetch on resume. that path turned out to be a footgun:
    // some chromium contexts (CDP-driven previews, certain
    // extensions, OS-level focus dances) fire visibilitychange at
    // ~1 Hz, and our resume-prime fired one count+list pair on each
    // event. the 60s setInterval would also be reset before it could
    // expire, so the only requests landing were the rapid primes.
    // chrome already throttles setInterval in hidden tabs to 1/min
    // — same as our intended cadence — so the visibility branch was
    // solving a problem that doesn't exist. left out by design.
  },
  beforeDestroy() {
    this.stopNotificationsPolling()
    if (this._ncRefreshHandler) {
      this.$root.$off('nc-refresh', this._ncRefreshHandler)
      this._ncRefreshHandler = null
    }
    if (this._tutorialClickHandler) {
      document.removeEventListener('click', this._tutorialClickHandler)
      this._tutorialClickHandler = null
    }
  },
  watch: {
    authenticated(newVal) {
      if (newVal) {
        this.startNotificationsPolling()
      } else {
        this.stopNotificationsPolling()
      }
    },
  },
  // mounted() {
  //   console.log("mounted: " + this.$route.fullPath)
  //   const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  //   console.log("mounted3: user=" + user)
  //   this.set_user_data(user)
  //
  //   if (!user || this.$route.name != "login") {
  //     console.log("mounted4: login redirect")
  //     this.$router.replace({name: "login", params: {nextUrl: this.$route.fullPath}});
  //   } else {
  //     this.authenticated = true;
  //   }
  // },
  methods: {
    setAuthenticated(status) {
      this.authenticated = status;
      if (!status) {
        this.logout();
      }
    },
    logout() {
      localStorage.clear()
    },
    showAlert(msg, variant, autoclose) {
      if (this._alertTimeout) clearTimeout(this._alertTimeout)
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      this._alertTimeout = autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    ...mapMutations('profile', [ 'set_user_data' ]),
    // FI-1432 notification polling. a single 60s interval drives unread
    // count; every second tick (120s) we also fetch the full list so an
    // open dropdown has fresh rows. list fetch errors are swallowed
    // silently — next tick retries.
    isTbnTenant() {
      try {
        const tenant = this.user && this.user.tenant
        const types = this.user && this.user.types
        return tenant && types && types[tenant] === 'TBN'
      } catch (_) { return false }
    },
    async pollNotifications(includeList) {
      const tenant = this.user && this.user.tenant
      if (!tenant) return
      const tbn = this.isTbnTenant()
      try {
        const countFn = tbn ? tbn_get_notifications_unread_count : cm_get_unread_count
        const countResp = await countFn(tenant)
        const count = this._extractCount(countResp)
        if (count != null) {
          this.$store.commit('notifications/set_unread_count', count)
        }
      } catch (_) { /* retry next tick */ }
      if (!includeList) return
      try {
        const listFn = tbn ? tbn_get_user_notifications : cm_get_user_notifications
        const listResp = await listFn(tenant, 20)
        const items = this._extractItems(listResp)
        if (items) {
          this.$store.commit('notifications/set_notifications', items)
        }
      } catch (_) { /* retry next tick */ }
    },
    // execute_generator(...).next() resolves to {value, done} where
    // value is the axios response. axios wraps the HTTP body at
    // value.data, and our ApiSuccessResponse wraps it AGAIN as
    // {status, message, data: <payload>, ...}. so the real payload
    // typically lives at resp.value.data.data — two layers deeper than
    // the naive resp.data check. walk through both possibilities so the
    // extractors work whether the response is already-unwrapped or
    // double-wrapped.
    _responsePayload(resp) {
      if (!resp) return null
      const axiosData = (resp.value && resp.value.data) || resp.data || resp
      if (!axiosData) return null
      return axiosData.data || axiosData
    },
    _extractCount(resp) {
      const payload = this._responsePayload(resp)
      if (payload && typeof payload.count === 'number') return payload.count
      return null
    },
    _extractItems(resp) {
      const payload = this._responsePayload(resp)
      if (payload && Array.isArray(payload.items)) return payload.items
      return null
    },
    startNotificationsPolling() {
      if (this._notifPollTimer) return
      this._notifPollTicks = 0
      this._wsActive = false
      // prime immediately so the badge is accurate on login
      this.pollNotifications(true)
      this._scheduleNotifPollTimer(POLL_INTERVAL_FAST_MS)
      // FI-1657: start the live-push WebSocket alongside polling. when
      // it connects we drop the timer to 5min; on any close we
      // immediately restore 60s. polling is the always-on safety net so
      // a failed WS attempt is invisible to the user.
      this.startWsConnection()
    },
    stopNotificationsPolling() {
      if (this._notifPollTimer) {
        clearInterval(this._notifPollTimer)
        this._notifPollTimer = null
      }
      this._notifPollTicks = 0
      this.stopWsConnection()
      this.$store.commit('notifications/set_unread_count', 0)
      this.$store.commit('notifications/set_notifications', [])
    },
    // restart the poll setInterval at the requested cadence, preserving
    // the tick count so the every-other-tick list refresh keeps working.
    _scheduleNotifPollTimer(intervalMs) {
      this._stopNotifPollTimer()
      this._notifPollTimer = setInterval(() => {
        this._notifPollTicks += 1
        // every 2nd tick (~120s at the fast cadence) also refreshes
        // the list, not just the unread count.
        this.pollNotifications(this._notifPollTicks % 2 === 0)
      }, intervalMs)
    },
    _stopNotifPollTimer() {
      if (this._notifPollTimer) {
        clearInterval(this._notifPollTimer)
        this._notifPollTimer = null
      }
    },
    startWsConnection() {
      const url = process.env.VUE_APP_WS_URL
      const jwt = window.localStorage.getItem('jwt')
      if (!url || !jwt) {
        // DEV path or unprovisioned stage: poll-only, no WS.
        return
      }
      if (!this._notifWs) this._notifWs = new NotificationsWs()
      this._notifWs.start(url, jwt, {
        onConnect: () => {
          // healthy WS: stop polling entirely and prime once to catch
          // anything that landed during the connect gap. push signals
          // drive every refresh from here on; nc-refresh (navbar
          // dropdown open) still fires an immediate poll on demand.
          this._wsActive = true
          this._stopNotifPollTimer()
          this.pollNotifications(true)
        },
        onSignal: () => {
          // server says "go fetch": refresh count + list now.
          if (this.authenticated) this.pollNotifications(true)
        },
        onDisconnect: () => {
          // any close (failed open or dropped session): restart 60s
          // polling immediately so the user doesn't sit on stale state
          // while the client retries the WS in the background. WS
          // retries forever with capped backoff; if it reconnects we
          // stop polling again on the next onConnect.
          if (this._wsActive || !this._notifPollTimer) {
            this._wsActive = false
            this._scheduleNotifPollTimer(POLL_INTERVAL_FAST_MS)
          }
        },
      })
    },
    stopWsConnection() {
      if (this._notifWs) {
        this._notifWs.stop()
      }
      this._wsActive = false
    },
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
    }),
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
  }
}
</script>

<style>
.bg-info {
  background-color: steelblue !important;
}

/* exclude .btn so Bootstrap/BV buttons rendered as <a> (e.g. b-button :to)
   keep their variant text color. `:where()` contributes zero specificity
   so this selector is (0,0,1) — same as bare `a` — and lets per-class
   overrides like navbar.vue's `.nav-link { color: white !important }` and
   `.profile-dd-btn.btn-outline-secondary { color: #6c757d !important }`
   keep winning on normal specificity rules. Using `a:not(.btn)` directly
   bumps this to (0,1,1), which clobbers those intended overrides. */
a:where(:not(.btn)) { color: steelblue !important; }

.page-item.active .page-link {
  color: white !important;
  background-color: steelblue !important;
}
.btn-secondary { color: white !important; }

.tc-sticky-save {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  padding: 12px 24px;
  z-index: 1000;
  pointer-events: none;
}
.tc-sticky-save .d-flex {
  pointer-events: auto;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}
.tc-sticky-save .d-flex:hover {
  opacity: 1;
}
.tc-save-slide-enter-active {
  transition: transform 0.2s ease-out, opacity 0.2s ease-out;
}
.tc-save-slide-leave-active {
  transition: transform 0.15s ease-in, opacity 0.15s ease-in;
}
.tc-save-slide-enter, .tc-save-slide-leave-to {
  transform: translateY(16px);
  opacity: 0 !important;
}
.tc-unsaved-label {
  color: #856404;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  padding: 4px 14px;
  border-radius: 4px;
  font-weight: bold;
}

@keyframes tc-dirty-flash {
  0%   { background-color: transparent; }
  15%  { background-color: #fff3cd; }
  60%  { background-color: #fffde7; }
  100% { background-color: transparent; }
}
.tc-dirty-highlight {
  animation: tc-dirty-flash 2.4s ease-out forwards;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
  background-color: transparent !important;
  /* clip any horizontal overflow at the app boundary so wide tables, rows
     with Bootstrap's -15px margin, or absolutely-positioned elements can't
     push the document past the viewport and expose the body background. */
  overflow-x: hidden;
}

.container,
.container-fluid,
#app.container-fluid {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

/* notification-icons inline SVG wrapper (FI-1432). used wherever we
   render a custom brand monogram instead of an FA glyph. the SVG sets
   width/height to 1em so it scales with the parent's font-size — same
   sizing convention as FA icons — and inline-flex centers it on the
   text baseline. unscoped because every consumer (navbar, list, detail,
   banner, composer) renders the same wrapper class. */
.ni-svg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.ni-svg svg {
  display: block;
}

</style>
